import Base from './Base';

class Taxonomies extends Base {
    get(query = null, page = null, count = null, opts = null) {
        return this.getJSON(
            '/taxonomies',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    brands(query = null, page = null, count = null, opts = null) {
        return this.getJSON(
            '/brands',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    categories(query = null, page = null, count = null, opts = null) {
        return this.getJSON(
            '/categories',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    tags(query = null, page = null, count = null, opts = null) {
        return this.getJSON(
            '/tags',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    topics(query = null, page = null, count = null, opts = null) {
        return this.getJSON(
            '/topics',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    formats(query = null, page = null, count = null, opts = null) {
        return this.getJSON(
            '/formats',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }
}

export default Taxonomies;
